import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import { FEATURES } from '../constants/features';
import { MIN_SIDEBAR_WIDTH } from '../constants/sidebar';
import { TABS } from '../constants/tabs';
import Tab from './sidebar/Tab';
// For tab content that needs to be rendered outside of the iFrame
export default function ParentRenderedContent({
  tab,
  show,
  enabledFeatures,
  ApprovalsContent
}) {
  const showApprovalsContent = useMemo(() => {
    const isApprovalsEnabled = enabledFeatures && enabledFeatures.length && enabledFeatures.includes(FEATURES.APPROVALS);
    const isApprovalsTabSelected = tab === TABS.APPROVALS;
    return show && ApprovalsContent && isApprovalsEnabled && isApprovalsTabSelected;
  }, [tab, show, ApprovalsContent, enabledFeatures]); // Add other tabs here

  if (!showApprovalsContent) {
    return null;
  }

  const approvalsContent = showApprovalsContent && ApprovalsContent && /*#__PURE__*/_jsx(ApprovalsContent, {});

  return /*#__PURE__*/_jsx("div", {
    style: {
      width: '100%',
      minWidth: MIN_SIDEBAR_WIDTH
    },
    children: /*#__PURE__*/_jsx(Tab, {
      heading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `collaborationSidebar.tabs.${tab}`
      }),
      children: approvalsContent
    })
  });
}